<template>
  <div>
    <sub-page-tabs
      :selected-index.sync="selectedTabIndex"
      :tabs="tabs"
      use-hash-state
      height="48"
    >
      <template #append-right>
        <screen-tab-filtering-button
          :filtering-input.sync="filteringInput"
          :review="review"
        />
      </template>
      <template #prepend-content>
        <screen-tab-filtering-status-bar
          v-if="filteringInput.hasFiltersApplied()"
          :review="review"
          :filtering-input="filteringInput"
          @clear="resetFilteringInput"
        />
      </template>
      <page-tab-panel>
        <review-tab-pending
          :key="`pending-tab-${updateKey}`"
          :review="review"
          :current-researcher="currentResearcher"
          :filtering-input="filteringInput"
          :active="selectedTabIndex === 0"
          @clear-filtering-input="resetFilteringInput"
        />
      </page-tab-panel>
      <page-tab-panel>
        <review-tab-awaiting-you
          :key="`awaiting-you-tab-${updateKey}`"
          :review="review"
          :current-researcher="currentResearcher"
          :filtering-input="filteringInput"
          :active="selectedTabIndex === 1"
          @clear-filtering-input="resetFilteringInput"
        />
      </page-tab-panel>
      <page-tab-panel>
        <review-tab-your-votes
          :key="`your-votes-tab-${updateKey}`"
          :review="review"
          :current-researcher="currentResearcher"
          :filtering-input="filteringInput"
          :active="selectedTabIndex === 2"
          @clear-filtering-input="resetFilteringInput"
        />
      </page-tab-panel>
      <page-tab-panel>
        <review-tab-conflicting
          :key="`conflicting-tab-${updateKey}`"
          :review="review"
          :current-researcher="currentResearcher"
          :filtering-input="filteringInput"
          :active="selectedTabIndex === 3"
          @clear-filtering-input="resetFilteringInput"
        />
      </page-tab-panel>
      <page-tab-panel>
        <review-tab-complete
          :key="`include-tab-${updateKey}`"
          :review="review"
          :current-researcher="currentResearcher"
          :filtering-input="filteringInput"
          :active="selectedTabIndex === 4"
          @clear-filtering-input="resetFilteringInput"
        />
      </page-tab-panel>
      <page-tab-panel>
        <review-tab-complete
          :key="`exclude-tab-${updateKey}`"
          :review="review"
          :current-researcher="currentResearcher"
          :filter-outcomes-to="['EXCLUDE']"
          :filtering-input="filteringInput"
          :active="selectedTabIndex === 5"
          @clear-filtering-input="resetFilteringInput"
        />
      </page-tab-panel>
    </sub-page-tabs>
    <screen-tab-status-footer
      v-if="review"
      :review="review"
      :current-researcher="currentResearcher"
      full-text-review
    />
    <screen-tab-status-footer-skeleton-loader v-else />
  </div>
</template>

<script>
import SubPageTabs from '@/components/Common/SubPageTabs';
import PageTabPanel from '@/components/Common/PageTabPanel';
import ReviewTabPending from './ReviewTabPending';
import ReviewTabAwaitingYou from './ReviewTabAwaitingYou';
import ReviewTabYourVotes from './ReviewTabYourVotes';
import ReviewTabConflicting from './ReviewTabConflicting';
import ReviewTabComplete from './ReviewTabComplete';
import ScreenTabStatusFooter from '@/components/ScreeningPageV2/ScreenTab/ScreenTabStatusFooter';
import ScreenTabStatusFooterSkeletonLoader from '@/components/ScreeningPageV2/ScreenTab/ScreenTabStatusFooterSkeletonLoader';
import ScreenTabFilteringButton from '@/components/ScreeningPageV2/ScreenTab/Filtering/ScreenTabFilteringButton';
import ScreenTabFilteringStatusBar from '@/components/ScreeningPageV2/ScreenTab/Filtering/ScreenTabFilteringStatusBar';
import {
  Review,
  Researcher,
  ReferenceFilteringInputDto,
} from '@/models';

export default {
  name: 'ReviewTab',
  components: {
    SubPageTabs,
    PageTabPanel,
    ReviewTabPending,
    ReviewTabAwaitingYou,
    ReviewTabYourVotes,
    ReviewTabConflicting,
    ReviewTabComplete,
    ScreenTabStatusFooter,
    ScreenTabStatusFooterSkeletonLoader,
    ScreenTabFilteringButton,
    ScreenTabFilteringStatusBar,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
    currentResearcher: {
      type: Researcher,
      required: true,
    },
  },
  data: () => ({
    selectedTabIndex: 0,
    filteringInput: new ReferenceFilteringInputDto(),
    updateKey: 0,
  }),
  computed: {
    tabs() {
      return [
        {
          label: 'Pending',
          count: this.review.fullTextReviewScreeningProgressSummary
            .unscreenedCount,
          hash: '#pending',
        },
        {
          label: 'Awaiting You',
          count: this.review.fullTextReviewScreeningProgressSummary
            .userRequiredVoteCount,
          hash: '#awaiting-you',
        },
        {
          label: 'Your Reviews',
          count: this.review.fullTextReviewScreeningProgressSummary
            .userVoteCount,
          hash: '#your-reviews',
        },
        {
          label: 'Conflicted',
          count: this.review.fullTextReviewScreeningProgressSummary
            .conflictedScreenCount,
          hash: '#conflicted',
        },
        {
          label: 'Included',
          count: this.review.fullTextReviewScreeningOutcomeSummary
            .relevantCount,
          hash: '#included',
        },
        {
          label: 'Excluded',
          count: this.review.fullTextReviewScreeningOutcomeSummary
            .notRelevantCount,
          hash: '#excluded',
        },
      ];
    },
  },
  watch: {
    selectedTabIndex() {
      this.updateKey += 1;
    },
  },
  methods: {
    resetFilteringInput() {
      this.filteringInput = new ReferenceFilteringInputDto();
    },
  },
};
</script>
